import Vue from 'vue'
import App from './App.vue'

import { VnToast, BsSetWebp, BsTrackExp, BsUtil } from 'dida-web-common'
import router from './router.js'

// 禁用浏览器的滚动位置恢复功能
function disableScrollRestoration() {
    if (history.scrollRestoration) {
        history.scrollRestoration = 'manual'
    }
}

// 初始化 Vue 实例
async function initVue() {
    Vue.directive('exposure', BsTrackExp)
    const isSuWebp = await BsSetWebp.init(Vue)
    Vue.use(VnToast)

    Vue.config.productionTip = false
    Vue.prototype.$bus = new Vue({ data: () => ({ store: {}}) })

    const vm = new Vue({
        data() {
            return {
                DATA: {},
                emitList: {},
                closeLoading: false,
                productName: '',
                shareData: {},
                isSuWebp,
                // 判断裂变活动客态和主态是否公用同一个页面
                liebianPageCommon: BsUtil.queryString('liebiancommon') || false,
                activeData: {
                    sceneCode: '',
                    activityCode: ''
                },
                updateInitData(acCode, acType, conditionList) {
                    // getActiveData(vm, acCode, acType, conditionList)
                }
            }
        },
        router,
        mounted() {
            // this.$track?.addplugin([BsTrackExp, BsTrackwaitTime])
        },
        render: h => h(App)
    }).$mount('#appRender')

    return vm
}

// 主初始化函数
async function init() {
    disableScrollRestoration()
    await initVue()
}

init()
